import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    headerContainer: {
        marginTop: 20,
    },
    headerboucher: {
       // color: '#ff8e4a',
        fontSize: 16,
        textAlign: 'right',
        paddingBottom: 2,
        display: "flex",
       flexDirection: "row",
       //width: '25%'
       marginLeft:"75%"
    },
    headerbouchercontent: {
        color: '#000',
        fontSize: 6,
        textAlign: 'right',
    },
    inline: {
        fontSize: 16,
       // textAlign: 'left',
        paddingBottom: 2,
        color: '#000',
        //marginLeft:200
      },
      inlineRight: {
        fontSize: 16,
        textAlign: 'right',
        paddingBottom: 2,
        color: '#ff8e4a',
      }
  });


  const BillVoucher = () => (
    <View style={styles.headerContainer}>
        
       
        <View style={styles.headerboucher}> 
        <Text style={styles.inline}>Itinerary  </Text>
        <Text  style={styles.inlineRight}> Details</Text>
        </View>
        <Text style={styles.headerbouchercontent}>This Itinerary is not confirmed</Text>
    </View>
  );
  
  export default BillVoucher